const getPhotoUrl=(photoUrl)=>{
  return photoUrl;
}

export default getPhotoUrl;